export default __webpack_public_path__ + "static/media/sale-img2.7f69cfce.webp";